import React from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import PageContainer from '../../components/login/PageContainer';
import OnboardingHeader from '../../components/onboarding/OnboardingHeader';
import { externalLinks, routes } from '../../constants';
import useRouter from '../../utils/useRouter';
import useScreenSize from '../../utils/useScreenSize';
import FooterLegalNavigation from '../../components/login/FooterLegalNavigation';
import appContext from '../../services/appContext.service';

const NewResetPasswordConfirmedPage: React.FC = () => {
  const { t } = useTranslation();
  const email = appContext.getResetPasswordEmail();
  const { router: { push } } = useRouter();
  const { isXsScreen, isSmScreen } = useScreenSize();

  return (
    <PageContainer pageBodySx={{ gap: 0 }}>
      <Box 
        data-testid='reset-password-confirmed-page'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: isXsScreen ? spaces.xl : spaces.xxxl,
        }}>
        <OnboardingHeader 
          title={t('E-Mail sent')}
          subtitle={t('The link to reset was sent to this address')}
        />
        <Box
          sx={{
            height: 'fit-content',
          }}
        >
          <Typography
            variant={isSmScreen ? 'body2' : 'body1'}
            sx={{ 
              color: palette.text.secondary,
              textAlign: 'center',
              marginTop: spaces.md,
            }}
          >
            <Trans i18nKey={'Please contact support...'}>
              <Link href={externalLinks.hilfe}></Link>
            </Trans>
          </Typography>
          <Box 
            sx={{ 
              marginTop: spaces.xxxxl,
              display: 'flex',
              justifyContent: 'center', 
            }}>
            <Typography
              variant='h6'
              sx={{ color: 'text.primary' }}
              data-testid='reset-password-confirmed-email'
            >
              {email}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 'auto',
        gap: spaces.lg,
      }}>
        <Button
          variant='outlined'
          size='large'
          color='primary'
          data-testid='send-link-per-email-button'
          onClick={() => { push(`/${routes.resetPassword.root}`); } }
        >
          {t('Resend Link')}
        </Button>
        <Button
          variant='text'
          size='medium'
          color='secondary'
          onClick={() => { push(`/${routes.login.root}`); } }
          data-testid='back-to-login-button'
        >
          {t('Back to login')}
        </Button>
      </Box>
      <FooterLegalNavigation isSmallScreen={isXsScreen} />
    </PageContainer>
  );
};

export default NewResetPasswordConfirmedPage;
